<!--抄表结算方案列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">抄表结算方案</span>
      </div>
      <div class="right">
        <Button @click="$router.push('meter-charge-add')" type="primary" >新增抄表结算方案</Button>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data"/>
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
export default {
  data () {
    return {
      columns: [
        { key: 'id', title: '标题' },
        { key: 'name', title: '名称' },
        { key: 'basics', title: '基础金额' },
        { key: 'type',
          title: '方案类型',
          render: (h, data) => {
            let type = {
              '1': '常规收费',
              '2': '区间收费',
              '3': '阶梯收费',
              '4': '常规高级',
              '5': '区间高级',
              '6': '阶梯高级'
            }
            return h('span', {}, type[data.row.type])
          } },
        { key: 'operate',
          title: '操作',
          render: (h, data) => {
            return h('div', {}, [
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '是否删除',
                      content: '是否删除该条方案?',
                      onOk: () => {
                        this.delMeterCharge(data.row.id)
                      }
                    })
                  }
                }
              }, '删除'),
              h('Button', {
                props: { type: 'info', size: 'small' },
                style: { marginLeft: '5px' },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'meter-charge-edit',
                      params: { id: data.row.id }
                    })
                  }
                }
              }, '详情')
            ])
          } }
      ],
      data: [],
      page: {
        p: 0,
        l: 10
      },
      total: 0,
      is_del: 0
    }
  },
  methods: {
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData () {
      this.GetMeterCharge({ p: this.page.p, l: this.page.l, is_del: this.is_del }).then(res => {
        this.data = res.data
        this.total = res.total
      })
    },
    delMeterCharge (id) {
      this.SaveMeterCharge({ id: id, is_del: 1 }).then(res => {
        this.getData()
        this.$Message.success('删除成功')
      })
    },
    ...mapActions(['GetMeterCharge', 'SaveMeterCharge'])
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({

  }),
  watch: {

  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
